export class Earth {
  constructor(difference) {
    this.width = 500
    this.height = 500
    this.top = 10
    this.left = 10
    this.type = "map"
    this.typeName = "地图"
    this.innerElement = "cxMap"
    this.refreshTime = null //间隔刷新时间
    this.updateTimer = null // 数据源轮询时间
    this.restDataUrl = "" // 外接数据源地址
    this.usePageQuery = false //页面传参
    this.initOptions = {
      renderer: "canvas"
    }
    this.init(difference)
  }
  init(difference) {
    this.chartOption = difference
    // for (let key in difference) {
    //   this[key] = difference[key]
    // }
  }
}
